import { render, staticRenderFns } from "./view_note.vue?vue&type=template&id=0a8d969b&scoped=true"
import script from "./view_note.vue?vue&type=script&lang=js"
export * from "./view_note.vue?vue&type=script&lang=js"
import style0 from "./view_note.vue?vue&type=style&index=0&id=0a8d969b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a8d969b",
  null
  
)

export default component.exports